import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!user) {
    // Carry the attempted destination so login can return them to it.
    // Without this, a tenant opening a deep link from an email (e.g. the
    // renewal concierge at /renewal/:termUuid) lands on the dashboard after
    // signing in with no way back to the page they were sent to.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const { firstName, lastName, email, phone, dob, location: userLocation } = user;
  const missing =
    !firstName || !lastName || !email || !phone || !dob || !userLocation?.address;

  if (missing) {
    return <Navigate to="/profile" state={{ from: location }} replace />;
  }

  // NOTE: a missing ACH mandate deliberately does NOT gate the app.
  //
  // Older tenants may have a bank payment method without one, and this used
  // to force a redirect to /payment-methods. That put a hard block in front
  // of everything — including paying a claim — for a problem that only
  // matters when a charge is actually attempted. `user.hasBankWithoutMandate`
  // is still returned and still drives the warning banner on
  // /payment-methods; it just no longer traps anyone there.
  return <Outlet />;
};

export default ProtectedRoute;
